import { Host, h } from '@stencil/core';
import cn from 'classnames';
import { DOCUMENTS, send, downloadDocumentEvent, getQdsIconLibrary } from '@pes-ui/utils';
import { PesProductLink } from '../../product-card/pes-product-link/pes-product-link';
class DocumentsList {
  constructor() {
    this.onDocumentLinkClick = (document) => {
      const { documentReference, documentName, documentType } = document;
      send(downloadDocumentEvent, { documentReference, documentName, documentType });
    };
    this.renderLink = (document) => {
      const { iconClass, title, url, cadProvider } = document;
      const isCadDocumentPopUp = cadProvider && cadProvider !== 'EDMS';
      return isCadDocumentPopUp ? (h("div", { "data-da-element-id": "doc_item", onClick: () => DocumentsList.openPopUp(url) }, DocumentsList.renderLinkContent(iconClass, title))) : (h("a", { href: url, "data-da-element-id": "doc_item", target: "_blank", onClick: () => this.onDocumentLinkClick(document), rel: "nofollow" }, DocumentsList.renderLinkContent(iconClass, title)));
    };
    this.open = undefined;
    this.documentsLabel = undefined;
    this.documents = undefined;
    this.viewAllDocumentsUrl = undefined;
    this.isGridView = undefined;
    this.pdpViewAllLabel = undefined;
    this.productId = undefined;
    this.enableAppRouting = undefined;
    this.tabId = DOCUMENTS;
    this.handleProductClick = undefined;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  static openPopUp(url) {
    const leftWindowBoundary = window.screenLeft || window.screenX || 0;
    const topWindowBoundary = window.screenTop || window.screenY || 0;
    const x = (window.screen.width - DocumentsList.POP_UP_WIDTH) / 2 + leftWindowBoundary;
    const y = (window.screen.height - DocumentsList.POP_UP_HEIGHT) / 2 + topWindowBoundary;
    window.open(url, DocumentsList.POP_UP_NAME, `height=${DocumentsList.POP_UP_VIEWPORT_HEIGHT},width=${DocumentsList.POP_UP_WIDTH},left=${x},top=${y}`);
  }
  static renderLinkContent(iconClass, title) {
    return (h("p", { class: "document-item" }, h("div", { class: `icon-file ${iconClass}` }), title));
  }
  getDropdownIconType() {
    if (this.open !== this.isGridView)
      return 'dropdown-close';
    return 'dropdown';
  }
  render() {
    return (h(Host, { class: this.isGridView ? 'grid-view' : 'list-view' }, h("div", { class: `document-backdrop
            ${this.isGridView ? 'grid-view' : 'list-view'}
            ${this.open ? 'open' : ''}` }), h("div", { class: `document
            ${this.isGridView ? 'grid-view' : 'list-view'}
            ${this.open ? 'open' : ''}` }, h("div", { class: cn('button-container', 'button-document', { open: this.open }), onClick: this.toggleDocumentView.emit }, h("qds-button", { size: "standard", importance: this.isGridView ? 'subdued' : 'standard', class: "button", "data-da-element-id": 'b_doc', iconName: "page-lines", iconLibrary: getQdsIconLibrary("page-lines"), text: this.documentsLabel, action: this.getDropdownIconType() })), h("div", { class: 'document-list' }, this.documents.map(this.renderLink), this.viewAllDocumentsUrl && (h(PesProductLink, { className: '', url: this.viewAllDocumentsUrl, id: this.productId, tabId: this.tabId, enableAppRouting: this.enableAppRouting }, h("qds-standalone-link", { class: 'link-all', href: this.viewAllDocumentsUrl, "data-da-element-id": 'doc_all', onClick: this.handleProductClick }, this.pdpViewAllLabel)))))));
  }
  static get is() { return "pdp-documents-list"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["documents-list.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["documents-list.css"]
    };
  }
  static get properties() {
    return {
      "open": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "open",
        "reflect": false
      },
      "documentsLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "documents-label",
        "reflect": false
      },
      "documents": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TProductDocument[]",
          "resolved": "TProductDocument[]",
          "references": {
            "TProductDocument": {
              "location": "import",
              "path": "../../../globals/types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "viewAllDocumentsUrl": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "view-all-documents-url",
        "reflect": false
      },
      "isGridView": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "is-grid-view",
        "reflect": false
      },
      "pdpViewAllLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "pdp-view-all-label",
        "reflect": false
      },
      "productId": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "product-id",
        "reflect": false
      },
      "enableAppRouting": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "PBS application routing functionality configuration."
        },
        "attribute": "enable-app-routing",
        "reflect": false
      },
      "tabId": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Tab id for scroll to a tab."
        },
        "attribute": "tab-id",
        "reflect": false,
        "defaultValue": "DOCUMENTS"
      },
      "handleProductClick": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "(event: MouseEvent) => void",
          "resolved": "(event: MouseEvent) => void",
          "references": {
            "MouseEvent": {
              "location": "global"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Callback for saving breadcrumbs in indexDB"
        }
      }
    };
  }
  static get events() {
    return [{
        "method": "toggleDocumentView",
        "name": "toggleDocumentView",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        }
      }];
  }
  static get elementRef() { return "el"; }
  static get stencilHasStaticMembersWithInit() { return true; }
}
DocumentsList.POP_UP_WIDTH = 580;
DocumentsList.POP_UP_HEIGHT = 800;
DocumentsList.POP_UP_VIEWPORT_HEIGHT = 670;
DocumentsList.POP_UP_NAME = 'CAD Publisher';
export { DocumentsList };
